var keyCodes = {};

export { keyCodes as __exports };
